/* src/app/shared/components/ag-tooltip-v2/ag-tooltip-v2.component.scss */
.ag-tooltip {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 2px 6px;
  height: auto;
  width: auto;
  background-color: #5c5c5c;
  border-radius: 3px;
  position: absolute;
  z-index: 1200 !important;
}
.header-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.header-container .title {
  font-family: "Poppins-Bold";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  color: #ffffff;
}
.body-regular {
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: #ffffff;
}
/*# sourceMappingURL=ag-tooltip-v2.component.css.map */
